import React, { useState } from "react";
import { useDeleteLogicoActividadPrograma } from "@/hooks/actividadesProgramas/useDeleteActividadPrograma";
import { AccionesGenericas } from "./AccionesGenericas";
import type { ActividadPrograma } from "@/interfaces/actividadPrograma.interface";
import { EditActividadProgramaForm } from "../forms/actividades-programas/EditActividadProgramaForm";
import { DetalleActividadPrograma } from "../dashboards/superAdmin/modales/ModalDetalleActividadPrograma";
import { Button } from "../ui/button";
import { FileText } from "lucide-react";
import { ModalReporteActividad } from "@/components/reportes/ModalReporteActividad";

type ActividadesProgramaProps = {
  actividad: ActividadPrograma;
};

export default function ActividadesProgramaActions({
  actividad,
}: ActividadesProgramaProps) {
  const { mutate } = useDeleteLogicoActividadPrograma();
  const [showReporteModal, setShowReporteModal] = useState(false);

  const handleOpenReporteModal = () => {
    setShowReporteModal(true);
  };

  return (
    <>
      <AccionesGenericas<ActividadPrograma>
        data={actividad}
        id={actividad.id}
        label="Actividad"
        queryKey={["actividadesProgramas"]}
        FormularioEdicion={EditActividadProgramaForm as React.ComponentType<{ data: ActividadPrograma; queryKey?: ReadonlyArray<unknown>; close: () => void }>}
        onDelete={(id) => mutate(id)}
        DetalleContenido={DetalleActividadPrograma}
        extraActions={() => (
          <Button
            size="icon"
            variant="icon"
            title="Generar reporte general"
            onClick={handleOpenReporteModal}
          >
            <FileText className="h-4 w-4 text-blue-600" />
          </Button>
        )}
      />
      <ModalReporteActividad
        actividad={actividad}
        open={showReporteModal}
        onOpenChange={setShowReporteModal}
      />
    </>
  );
}
